import React, { useEffect, useState } from "react";
import Spinner from "@/components/ui/Spinner";
import { useLocation, useSearchParams } from "react-router-dom";
import Layout from "@/components/layout/Layout";
import CreateCampaign from "./components/create-campaign";
import FlightSetup from "./components/flight-setup";
import useGlobalStore from "@/store/globalStore";
import { useShallow } from "zustand/react/shallow";
import AssetSetup from "./components/assets-setup";
import useCampaignStore from "./store/campaignStore";
import CampaignSummary from "./components/campaign-summary";

const CreateCampaignWrapper: React.FC = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const [searchParams] = useSearchParams();
  const location = useLocation();
  const { getSingleCampaign, campaign } = useCampaignStore(
    useShallow((state) => ({
      getSingleCampaign: state.getSingleCampaign,
      campaign: state.campaign,
    }))
  );
  const setError = useGlobalStore((state) => state.setError);

  const fetchData = async () => {
    if (
      (!campaign || searchParams.get("id") != campaign.campaign.id) &&
      searchParams.get("id")
    ) {
      setIsLoading(true);
      try {
        await getSingleCampaign(searchParams.get("id"));
      } catch (error) {
        setError(error?.message ?? "Something went wrong");
      } finally {
        setIsLoading(false);
      }
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  if (isLoading) {
    return (
      <div className="flex justify-center items-center w-screen h-screen">
        <Spinner size={30} />
      </div>
    );
  }

  if (!campaign && searchParams.get("id") && !isLoading) {
    return (
      <div className="flex flex-col justify-center items-center w-screen h-screen">
        <div className="font-bold text-2xl mb-4">Campaign Not Found</div>
        <div>Oops!! No Campaign Found. Please try again later.</div>
      </div>
    );
  }

  return (
    <Layout>
      {location.pathname === "/campaign" && <CreateCampaign />}

      {location.pathname === "/campaign/flight" && <FlightSetup />}

      {location.pathname === "/campaign/assets" && <AssetSetup />}

      {location.pathname === "/campaign/summary" && <CampaignSummary />}
    </Layout>
  );
};

export default CreateCampaignWrapper;
